import React from "react";

type Props = {
  className?: string;
  text?: string;
  loading?: boolean;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  isBorder?: boolean;
  classNameDiv?: string;
  disabled?: boolean;
  variant?: "red" | "gold";
};
const goldGradientText: React.CSSProperties = {
  background: "linear-gradient(90deg, #FFE3B0 0%, #F7C263 52.5%, #FFEFD1 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};
const ButtonExport = ({
  className,
  text,
  loading = false,
  onClick,
  type,
  isBorder,
  classNameDiv,
  disabled,
  variant = "red",
}: Props) => {
  const redStyle = `
  shadow-[0px_2px_4px_0px_#D0050066]
  bg-[#FF4209]
  `;

  const redInner = `
  bg-[linear-gradient(90deg,#B12C28_0%,#E32520_100%)]
  shadow-[0px_2px_4px_0px_#D0050066,0px_1px_8px_0px_#FF4209_inset]
  hover:bg-[linear-gradient(271.98deg,#8D130F_3.29%,#E32520_90.67%)]
  hover:shadow-[0px_-3px_4px_0px_#FF7931E5_inset,0px_2px_4px_0px_#D0050066,0px_4px_12px_0px_#FF4209_inset]
  `;

  const goldStyle = `
  border border-[#E8AC3D]
  bg-[linear-gradient(90deg,#FFE3B0_0%,#F7C263_52.5%,#FFEFD1_100%)]
  shadow-[0px_2px_4px_0px_#EACC24,0px_-3px_4px_0px_rgba(255,252,235,0.9)_inset]
  `;

  const goldInner = `
  bg-[linear-gradient(90deg,#FFE3B0_0%,#F7C263_52.5%,#FFEFD1_100%)]
  hover:bg-[linear-gradient(180deg,#FFD568_0%,#FFE4B3_50%,#F4A42B_100%)]
  `;

  const wrapperStyle = variant === "gold" ? goldStyle : redStyle;
  const innerStyle = variant === "gold" ? goldInner : redInner;

  return (
    <div
      className={`p-1 rounded-lg w-full h-[32px] md:h-[41px] transition-all duration-300 hover:scale-[1.02]
      ${wrapperStyle}
      ${loading || disabled ? "opacity-50 cursor-not-allowed" : ""}
      ${classNameDiv ?? ""}`}
    >
      <button
        onClick={onClick}
        disabled={loading || disabled}
        type={type ?? "button"}
        className={`relative py-2 px-3 h-full rounded-md w-full flex items-center justify-center
        font-bold sm:text-lg text-base font-mulish transition-all duration-300
        ${innerStyle}
        ${
          loading || disabled
            ? "pointer-events-none cursor-not-allowed"
            : "cursor-pointer"
        }
        ${className ?? ""}`}
      >
        {loading ? (
          <div className="flex items-center gap-2">
            <svg
              className="animate-spin w-5 h-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
                className="opacity-25"
              />
              <path
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                className="opacity-75"
              />
            </svg>
            <span>Đang xử lý...</span>
          </div>
        ) : (
          <div
            className={`whitespace-nowrap ${
              variant === "gold" ? "text-[#B12C28]" : ""
            }`}
            style={variant === "red" ? goldGradientText : undefined}
          >
            {text}
          </div>
        )}
      </button>
    </div>
  );
};

export default ButtonExport;
